export default function DateConvertor(date) {
  const inputDate = new Date(date);

  // Format time as HH:mm
  const options = { hour: "2-digit", minute: "2-digit", hour12: false };
  return new Intl.DateTimeFormat("en-US", options).format(inputDate);
}
